import React, { useContext, useMemo } from "react";
import PropTypes from "prop-types";
import { useLocation } from "react-router-dom";
import { GlobalContext } from "GlobalContext";

import MegaMenu from "components/MegaMenu";
import Topbar from "./Topbar";
import Navbar from "./Navbar";
import Hero from "./Hero";
import { HeroSkeleton } from "components/Skeleton";

import { HeaderWrapper } from "./styles/HeaderStyles";

import bg from "images/pattern-hero.png";

const Header = ({ hero }) => {
  const { isLoading, activeMegaMenu, heroData } = useContext(GlobalContext);
  // The homepage hero fills the first screen (/, /en, /en/).
  const isHome = /^\/(en\/?)?$/.test(useLocation().pathname);

  return useMemo(() => {
    return (
      <React.Fragment>
        <HeaderWrapper
          className={`header ${isHome ? "header--home" : ""}`}
          bg={bg}
        >
          <Topbar />
          <Navbar />
          {activeMegaMenu ? (
            <MegaMenu />
          ) : isLoading ? (
            hero && <HeroSkeleton />
          ) : (
            hero && heroData.image.sourceUrl && <Hero home={isHome} />
          )}
        </HeaderWrapper>
      </React.Fragment>
    );
  }, [isLoading, activeMegaMenu, heroData, isHome]);
};

Header.propTypes = {
  hero: PropTypes.bool,
};

Header.defaultProps = {
  hero: true,
};

export default Header;
